// © Thibault Sabathier, 2025. Tous droits réservés.
// frontend/src/components/education/DegreeSelect.js
// Select contrôlé pour le diplôme + champ libre si "Autre"

import React from 'react'
import { CFormSelect, CFormInput, CRow, CCol } from '@coreui/react'
import { useTranslation } from 'react-i18next'

// `value` = identifiant DB (NE JAMAIS traduire).
// `labelKey` = clé i18n résolue au render (i18n pas prêt au niveau module).
// `label` = libellé FR conservé pour rétrocompatibilité des consommateurs
// externes (EducationManager, MemberEducationViewer) hors périmètre de ce lot.
const DEGREE_TYPES = [
  { value: 'cap', labelKey: 'education:degree_cap', label: 'CAP' },
  { value: 'bep', labelKey: 'education:degree_bep', label: 'BEP' },
  { value: 'bac', labelKey: 'education:degree_bac', label: 'Baccalauréat' },
  { value: 'bac_pro', labelKey: 'education:degree_bac_pro', label: 'Bac Professionnel' },
  { value: 'bts', labelKey: 'education:degree_bts', label: 'BTS' },
  { value: 'dut', labelKey: 'education:degree_dut', label: 'DUT / BUT' },
  { value: 'licence', labelKey: 'education:degree_licence', label: 'Licence (Bac+3)' },
  {
    value: 'licence_pro',
    labelKey: 'education:degree_licence_pro',
    label: 'Licence Professionnelle',
  },
  { value: 'master', labelKey: 'education:degree_master', label: 'Master (Bac+5)' },
  { value: 'master_pro', labelKey: 'education:degree_master_pro', label: 'Master Professionnel' },
  { value: 'ingenieur', labelKey: 'education:degree_ingenieur', label: "Diplôme d'Ingénieur" },
  { value: 'doctorat', labelKey: 'education:degree_doctorat', label: 'Doctorat (PhD)' },
  { value: 'bachelor', labelKey: 'education:degree_bachelor', label: 'Bachelor' },
  { value: 'mba', labelKey: 'education:degree_mba', label: 'MBA' },
  { value: 'other', labelKey: 'education:degree_other', label: 'Autre' },
]

export { DEGREE_TYPES }

const DegreeSelect = ({ degreeType, degreeCustom, onChange }) => {
  const { t } = useTranslation()
  const handleTypeChange = (e) => {
    const newType = e.target.value
    onChange({
      degree_type: newType || null,
      degree_custom: newType === 'other' ? degreeCustom : null,
    })
  }

  const handleCustomChange = (e) => {
    onChange({
      degree_type: 'other',
      degree_custom: e.target.value,
    })
  }

  return (
    <CRow className="g-2">
      <CCol xs={degreeType === 'other' ? 6 : 12}>
        <CFormSelect value={degreeType || ''} onChange={handleTypeChange}>
          <option value="">{t('education:degree_placeholder')}</option>
          {DEGREE_TYPES.map((d) => (
            <option key={d.value} value={d.value}>
              {t(d.labelKey)}
            </option>
          ))}
        </CFormSelect>
      </CCol>
      {degreeType === 'other' && (
        <CCol xs={6}>
          <CFormInput
            value={degreeCustom || ''}
            onChange={handleCustomChange}
            placeholder={t('education:degree_custom_placeholder')}
          />
        </CCol>
      )}
    </CRow>
  )
}

export default DegreeSelect
